import { render, staticRenderFns } from "./TaxableIncomeKPM.vue?vue&type=template&id=d572ff56"
import script from "./TaxableIncomeKPM.vue?vue&type=script&lang=js"
export * from "./TaxableIncomeKPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d572ff56')) {
      api.createRecord('d572ff56', component.options)
    } else {
      api.reload('d572ff56', component.options)
    }
    module.hot.accept("./TaxableIncomeKPM.vue?vue&type=template&id=d572ff56", function () {
      api.rerender('d572ff56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/reports/TaxableIncomeKPM.vue"
export default component.exports